"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Input;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = require("react");

var _InputModule = _interopRequireDefault(require("../../assets/styles/components/Input.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Input(_ref) {
  let {
    innerRef,
    defaultValue,
    label = "",
    value,
    onChange: _onChange,
    placeholder,
    type = "text",
    startEnhancer,
    endEnhancer,
    size = "default",
    disabled,
    error,
    positive,
    readOnly,
    styling = {},
    max,
    min,
    maxlength,
    autoFocus
  } = _ref;
  const [input_value, setinput_value] = (0, _react.useState)("");
  const input = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    return () => {
      document.removeEventListener("keydown", null);
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (value !== "") {
      setinput_value(value);
    }
  }, [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: styling,
    className: "\n            ".concat(_InputModule.default.input, "\n            ").concat(size === "mini" ? _InputModule.default.size_mini : size === "compact" ? _InputModule.default.size_compact : size === "default" ? _InputModule.default.size_default : size === "large" ? _InputModule.default.size_large : _InputModule.default.size_default, "\n            ").concat(error && _InputModule.default.error_true, "\n            ").concat(positive && _InputModule.default.positive_true, "\n        "),
    children: [label !== "" && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: _InputModule.default.label,
      children: label
    }), startEnhancer && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _InputModule.default.startEnhancer,
      children: startEnhancer
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ref: innerRef,
      defaultValue: defaultValue,
      autoFocus: autoFocus,
      maxLength: maxlength,
      min: min,
      max: max,
      readOnly: readOnly,
      disabled: disabled,
      ref: input,
      type: type,
      value: input_value || "",
      placeholder: placeholder,
      onChange: e => {
        setinput_value(e.currentTarget.value);

        _onChange(e.currentTarget);
      }
    }), endEnhancer && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _InputModule.default.endEnhancer,
      children: endEnhancer
    })]
  });
}